<template>
  <a-layout>
    <a-space>
      <a-input-search v-model="query['order.no']" :placeholder="$t('placeholder.receiptOrderNo')" class="query" @pressEnter="search()" @search="search()" />
      <a-select v-model="query['owner.id']" :placeholder="$t('placeholder.ownerName')" allowClear class="query" @change="search()">
        <a-select-option v-for="d in owners" :key="d.id">{{d.name}}</a-select-option>
      </a-select>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px"
      @cell-click="({row})=>rowClick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="order.no" title="business.label.receiptOrderNo"/>
      <vxe-column field="owner.name" title="business.label.ownerName" width="120"/>
      <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
      <vxe-column field="asnOrder.orderStatus" title="business.label.orderStatus" width="100">
        <template slot-scope="{ row }">{{ orderStatusData.length === 0 ? row.asnOrder.orderStatus : orderStatusData.find(item => item.ordinal === row.asnOrder.orderStatus).name }}</template>
      </vxe-column>
      <vxe-column field="orderType.name" title="business.label.orderType" width="120" />
    </vxe-table>
    <vxe-pager :current-page="page" :loading="loading" :page-size="size" :pageSizes="[5, 10, 15, 20]" :total="contentSize" @page-change="pageChange"/>
  </a-layout>
</template>

<script>
import moment from 'moment'
import { findAll } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'InspectOrder',
    data() {
      return {
        data: [],
        contentSize: 0,
        page: 1,
        size: 5,
        loading: false,
        query: {
          'order.no': '',
          'owner.id': undefined,
          'refundable': false,
          'asnOrderStatusRange': { 'start': 'SUBMITTED', 'end': 'INSPECTING' }
        },
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.225)
      }
    },
    props: {
      orderStatusData: {
        type: Array,
        default: []
      },
      owners: {
        type: Array,
        default: []
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      pageChange({ currentPage, pageSize }) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      moment,
      search() {
        this.page = 1
        this.getData()
      },
      getData() {
        this.loading = true
        findAll('receivingReceiptListFactory', this.query, this.page, this.size).then(res => {
            this.contentSize = res.contentSize
            this.data = res.result
            if (this.data.length > 0) {
              this.$refs.table.setRadioRow(this.data[0])
              this.$refs.table.setCurrentRow(this.data[0])
              this.rowClick(this.data[0])
            }
          }).finally(() => {
          this.loading = false
        })
      },
      rowClick(row) {
        this.$emit('rowClick', row.order.id)
      },
      reset() {
        this.query['order.no'] = ''
        this.query['owner.id'] = undefined
        this.getData()
      }
    }
  }
</script>
<style scoped>
  .query {
    width: 200px;
  }
</style>